import {
  fetchDeliveryList,
  fetchCustomerList,
  deleteCustomer,
  addCustomerDeliveryUser,
  fetchDeliveryAppDomain,
  fetchDeliveryAppStatus,
  fetchDeliveryAppsInfo,
  operationDeliveryApps
} from '@/api/delivery';

const delivery = {
  state: {},

  mutations: {},

  actions: {
    // 查询商店交付应用列表
    GetDeliveryList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询交付详情
    GetDeliveryAppsInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppsInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 交付操作
    OperationDeliveryApps({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        operationDeliveryApps(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询交付客户列表
    GetCustomerList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchCustomerList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 删除交付客户
    DeleteCustomer({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteCustomer(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 添加交付客户应用列表
    AddCustomerDeliveryUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addCustomerDeliveryUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    // 应用状态
    GetDeliveryAppStatus({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppStatus(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 应用基础信息
    GetDeliveryAppDomain({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppDomain(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }

  }
};

export default delivery;



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js